<template>
	<div v-if="loading" class="text-center">
	    Loading PDF Builder <i class="fa fa-circle-o-notch fa-spin"></i>
	</div>
	<div v-else>
		<div>
			<vue-headful :title="'Build PDF [CustomForm-'+entry.covid_form_name+'-Date-'+entry.created_at+'] :: MeritEHS'"/>

			<h4 class="py-3 mb-4">
			    <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/custom-forms`">
			                <i class="fa fa-list"></i> Custom Forms
			            </router-link>
			        </li>
			        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
			            <router-link :to="`/custom-forms/entry/view/${entry.id}`">
			                {{ entry.covid_form_name }} -
			                <template v-if="entry.employee_id">
			                    {{ entry.FirstName }} {{ entry.LastName }}
			                </template>
			                <template v-else>
			                    {{ entry.person_name }}
			                </template>
			                - {{ entry.created_at | moment("MM/DD/YYYY") }}
			            </router-link>
			        </li>
			        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Build PDF</li>
			    </ol>
			</h4>

			<div class="row">
				<div class="col-lg-8 col-12">
					<div class="card">
						<div class="card-header">
							Custom Form PDF
						</div>
						<div class="card-body">
							<div class="mb-4">
							    <strong>PDF Settings:</strong>
							    <ol>
							        <li class="mb-1" v-if="pdfLogo">
							            <span>Show/Hide Logo:</span>
							            <select v-model="showLogo">
							                <option :value="true">Show Logo</option>
							                <option :value="false">Hide Logo</option>
							            </select>
							            <span class="small">Show/Hide your company logo on the Custom Form PDF report.</span>
							        </li>
							    </ol>
							</div>

							<div>
							    <strong>PDF:</strong>
							    <template v-if="building">
							    	Building PDF <i class="fa fa-circle-o-notch fa-spin"></i>
							    </template>
							    <template v-else-if="file_name">
							    	<a :href="`/files/pdf/${file_name}`" target="_blank" title="Preview PDF">{{ file_name }}</a>
							    </template>
							</div>
						</div>
						<div class="card-footer">
							<button class="btn btn-sm btn-info d-sm-inline-block d-block mb-sm-0 mb-1" v-on:click="buildPDF()" :disabled="building || sending">
								<template v-if="!building">Build PDF</template>
								<template v-else><i class="fa fa-spin fa-spinner"></i> Building PDF</template>
							</button>

							<template v-if="file_name">
								<a :href="`/files/pdf/${file_name}`"
									target="_blank"
									title="Download PDF"
									class="btn btn-sm btn-default mb-sm-0 mb-1"
									:disabled="building || sending">
									Download PDF
								</a>
								<button
									class="btn btn-sm btn-default d-sm-inline-block d-block mb-sm-0"
									v-on:click="sendEmail()"
									:disabled="building || sending">
									Email PDF to Me ({{ $store.state.user.email }})
								</button>
							</template>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import moment from 'moment-timezone';

	export default {
	    data: function() {
	        return {
	            loading: true,
	            building: false,
	            sending: false,
	            id: this.$route.params.id,
	            entry: {},
	            errors: {},
	            insp_config: null,
	            configs: [],
	            options: [],
	            file_name: null,
	            file_path: null,

	            showLogo: true,
	            files: [],
	            imagesLoading: false,
	            pdfs_proccessing: false,
	            pdfLogo: null,
	            custom_field_sections: [],
	            personnel: [],

	            //Email Config
	            subject: null,
	            email_body: null,
	            to: [
	            	this.$store.state.user.email,
	            ],
	        }
	    },

	    watch: {
	    	showLogo(newVal, oldVal){
	    		//Reset the Values
	    		this.file_name = null;
	    		this.file_path = null;

	    		//Build it
	    		this.buildPDF();
	    	},
	    },

	    computed: {
	    	owner(){
	    		//Check Employee
	    		if(this.entry.employee_id)
	    		{
	    			return this.entry.FirstName + ' ' + this.entry.LastName;
	    		}

	    		//Send persoin
	    		return this.entry.person_name;
	    	},

	    	created(){
	    		//Setup
	    		if(!this.entry.created_at)
	    		{
	    			return null;
	    		}

	    		//Setup
	    		var date = new moment(this.entry.created_at);

	    		//Return
	    		return date.format('MM/DD/YYYY');
	    	},
	    },

	    methods: {

	        getCustomFormEntry() {
	        	//Get the data
	        	this.$http
	        	    .get('/custom-forms/entry/view/' + this.id + '?pdf=true')
	        	    .then(response => {
	        	        //Set all the data
	        	        this.entry = response.data.entry;
	        	        this.personnel = response.data.personnel;
	        	        this.files = response.data.files;
	        	        this.pdfs_proccessing = response.data.pdfs_proccessing;
	        	        this.pdfLogo = response.data.pdfLogo;

	        	        //Setup Some Email Stuff
	        	        this.subject = 'MeritEHS PDF for CustomForm-'+this.entry.covid_form_name+' on '+this.created+' for '+this.entry.JobsiteNumber+' - '+this.entry.JobsiteName;
	        	        this.email_body = 'Form: '+this.entry.covid_form_name+'\n'+
	        	        					'Date: '+this.created+'\n'+
	        	        					'Completed By: '+this.owner+'\n'+
	        	        					'Jobsite: '+this.entry.JobsiteNumber+' - '+this.entry.JobsiteName+'\n\n'+
	        	        					'See attached PDF';

	        	        //Build it
	        	        this.buildPDF();
	        	    })
	        	    .catch(response => {

	        	    })
	        	    .then(() => {
	        	    	//Reset Loading
	        	    	this.loading = false;
	        	    });
	        },

	        buildPDF(){
	        	//Helper
	        	this.building = true;

	        	//Build the Payload
	        	var payload = {
			    	show_logo: this.showLogo,
	        	};

	            //Get the data
	            this.$http
	                .get('/custom-forms/entry/pdf/'+this.id, payload)
	                .then(response => {
		                //Set all the data
		                this.file_path = response.data.file_path;
		                this.file_name = response.data.file_name;

	                })
	                .catch(response => {

	                })
	                .then(() => {
	                	//Reset
	                	this.loading = false;
	                	this.building = false;
	                });
	        },

			sendEmail() {
			    //Show loading
			    this.sending = true;

			    //Reset the errors
			    this.errors = {};

			    //Setup
			    var payload = {
			    	subject: this.subject,
			    	email_body: this.email_body,
			    	to: this.to,
			    	file_path: this.file_path,
			    };

			    //Get the data
			    this.$http
			        .post('/custom-forms/entry/pdf/'+this.id, payload)
			        .then(response => {
			            //Alert
			            this.$toastr.success('PDF Sent. Check your email.');

			            //Push back
			            //this.$router.push('/custom-forms/view/'+this.id);
			        })
			        .catch(error => {
			        	//Check for error
			        	if(error.response.status === 422)
			        	{
			        	    //Display validation errors
			        	    this.errors = error.response.data
			        	}
			        	else
			        	{
			        	    //Alert the user
			        	    this.$toastr.error(error.response.data, 'Failed to Email Custom Form PDF');
			        	}
			        })
			        .then(() => {
			        	//Reset
			        	this.sending = false;
			        });
			},
	    },

	    mounted() {
	        //Get the custom-forms
	        this.getCustomFormEntry();
	    },
	}
</script>